export const METRIC_OPTIONS = [
  { label: 'Impression', value: 'impressions' },
  { label: 'Payout', value: 'payout', currency: 'EUR' },
  { label: 'Video Starts', value: 'video_starts' },
]

export const NUMBER_FORMAT = 'de-DE'

export const METRIC_TO_KEY_MAPPING = {
  impressions: 'impressions',
  payout: 'payout',
  video_starts: 'video_starts',
}



// WEBPACK FOOTER //
// ./src/components/Pages/Report/constants.js